const resources = {
    free: 'GRATUIT',
    biFreeShip: 'Les membres Beauty Insider profitent de la *livraison standard GRATUITE* sur toutes les commandes.',
    biFreeShipTest: 'Votre commande est admissible à *{Color:Red}la livraison standard GRATUITE.{Color}*'
};

module.exports = function getResource(label) {
    return resources[label];
};
